import { useRef } from 'react';

// Single shared drop zone for both countries — schema detection happens per
// file in detectSchema.js, not here. Uses a drag-depth counter (rather than a
// plain boolean) so dragging over child elements doesn't flicker the
// highlight, ported from invoice-loader-react's UploadZone.
export default function UploadZone({ isDragging, isProcessing, onFiles, onDragState }) {
  const fileInputRef = useRef(null);
  const dragDepth = useRef(0);

  const handleFileInput = (e) => {
    onFiles(e.target.files);
    e.target.value = '';
  };

  return (
    <div
      onClick={() => fileInputRef.current?.click()}
      onDrop={(e) => {
        e.preventDefault();
        // Stop propagation so a page-level "drop it in the zone" guard (if
        // one exists) doesn't also fire for a drop that landed correctly.
        e.stopPropagation();
        dragDepth.current = 0;
        onDragState(false);
        onFiles(e.dataTransfer.files);
      }}
      onDragEnter={(e) => {
        e.preventDefault();
        dragDepth.current += 1;
        onDragState(true);
      }}
      onDragOver={(e) => e.preventDefault()}
      onDragLeave={() => {
        dragDepth.current = Math.max(0, dragDepth.current - 1);
        if (dragDepth.current === 0) onDragState(false);
      }}
      className={`border-2 border-dashed rounded-2xl p-10 text-center cursor-pointer select-none transition-all ${
        isDragging
          ? 'border-brand-500 bg-brand-500/5'
          : 'border-gray-300 bg-white hover:border-brand-400 hover:bg-brand-500/5'
      }`}
    >
      <input
        ref={fileInputRef}
        type="file"
        multiple
        accept=".xml,.json,.zip"
        className="hidden"
        onChange={handleFileInput}
      />
      <div className="mb-3">
        {isProcessing ? (
          <svg className="mx-auto animate-spin text-brand-600" width="36" height="36" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
          </svg>
        ) : (
          <svg className="mx-auto text-gray-400" width="40" height="40" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5m-13.5-9L12 3m0 0l4.5 4.5M12 3v13.5" />
          </svg>
        )}
      </div>
      <p className="text-gray-700 font-semibold">Arrastra tus documentos aquí</p>
      <p className="text-gray-400 text-sm mt-1">o haz clic para seleccionar · XML, JSON o ZIP · múltiples archivos permitidos</p>
      <p className="text-gray-300 text-xs mt-3">Detecta automáticamente Costa Rica (FacturaElectronica) y El Salvador (DTE)</p>
    </div>
  );
}
